import React from 'react'
import {
  OneCenteredDot,
  TwoDots,
  ThreeDots,
  FourDots,
  Placeholder
} from '../../common/SmartRateDots'
import permutationMapping from '../configs/permutationMapping'

const dots = {
  1: OneCenteredDot,
  2: TwoDots,
  3: ThreeDots,
  4: FourDots
}

export default ({ dataPermutation, color, usePlaceholder = false }) => {
  const numDots = permutationMapping[dataPermutation]
  const Dot = dots[numDots]
  if (usePlaceholder) {
    // If there is no match for the number of dots, return the placeholder
    return Dot ? <Dot color={color} /> : <Placeholder />
  } else {
    return Dot ? <Dot color={color} /> : null
  }
}
